import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Search, X } from "lucide-react";

export default function SearchBar({ onSearch }) {
  const [value, setValue] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch(value);
  };

  const handleClear = () => {
    setValue("");
    onSearch("");
  };

  return (
    <form onSubmit={handleSubmit} className="relative w-full">
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-[#52525b] h-4 w-4" />
      <Input
        data-testid="search-input"
        type="text"
        placeholder="Search by title..."
        value={value}
        onChange={(e) => setValue(e.target.value)}
        className="pl-10 pr-10 bg-[#21252b] border-[#2a2e36] text-[#e4e4e7] placeholder:text-[#52525b] focus-visible:ring-[#a08a58] focus-visible:border-[#a08a58] h-10 text-sm rounded-xl"
      />
      {value && (
        <button
          data-testid="search-clear-btn"
          type="button"
          onClick={handleClear}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-[#52525b] hover:text-[#c6a96f] transition-colors"
        >
          <X className="h-4 w-4" />
        </button>
      )}
    </form>
  );
}
